export const baseURL = "https://expo2022.forummediterraneosanita.it";
